/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortalMessage } from './PortalMessage';
import {
    PortalMessageFromJSON,
    PortalMessageFromJSONTyped,
    PortalMessageToJSON,
} from './PortalMessage';

/**
 * 
 * @export
 * @interface PortalConfig
 */
export interface PortalConfig {
    /**
     * 
     * @type {boolean}
     * @memberof PortalConfig
     */
    preview?: boolean | null;
    /**
     * 
     * @type {Array<PortalMessage>}
     * @memberof PortalConfig
     */
    messages?: Array<PortalMessage> | null;
}

/**
 * Check if a given object implements the PortalConfig interface.
 */
export function instanceOfPortalConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortalConfigFromJSON(json: any): PortalConfig {
    return PortalConfigFromJSONTyped(json, false);
}

export function PortalConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preview': !exists(json, 'preview') ? undefined : json['preview'],
        'messages': !exists(json, 'messages') ? undefined : (json['messages'] === null ? null : (json['messages'] as Array<any>).map(PortalMessageFromJSON)),
    };
}

export function PortalConfigToJSON(value?: PortalConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'preview': value.preview,
        'messages': value.messages === undefined ? undefined : (value.messages === null ? null : (value.messages as Array<any>).map(PortalMessageToJSON)),
    };
}

